var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: { label: "Nome:", content: _vm.imovel.nome }
              }),
              _vm._v(" "),
              _vm.imovel.possuiCar
                ? _c("app-display", {
                    attrs: {
                      label: "Número(s) do CAR:",
                      content: _vm.formataNumeroCar(
                        _vm.imovel.numerosRecibosCar
                      ),
                      isContentInNextLine: true
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Possui CAR?",
                  content: _vm.imovel.possuiCar ? "Sim" : "Não"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: { label: "CEP:", content: _vm.imovel.endereco.cep }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Logradouro:",
                  content: _vm.imovel.endereco.logradouro
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: { label: "Número:", content: _vm.imovel.endereco.numero }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Município/UF:",
                  content: _vm.imovel.endereco.municipio
                    ? _vm.formataMunicipioUF(_vm.imovel.endereco.municipio)
                    : ""
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Comunidade ou localidade:",
                  content: _vm.imovel.endereco.comunidadeLocalidade
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Referência de acesso:",
                  content: _vm.imovel.endereco.referencia
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("el-row", [
        _vm.imovel.registroImovel.situacao === "PROPRIETARIO"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Número da matrícula:",
                        content:
                          _vm.imovel.registroImovel.proprietarioImovel
                            .numeroMatricula
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.imovel.registroImovel.situacao === "POSSEIRO"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Tipo de posse:",
                        content: _vm.formataTipoPosse(
                          _vm.imovel.registroImovel.posseiro.tipoPosse
                        )
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.imovel.registroImovel.posseiro.tipoPosse === "OUTROS"
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: {
                            label: "Especificação:",
                            content:
                              _vm.imovel.registroImovel.posseiro.detalhePosse
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.imovel.registroImovel.situacao === "ASSENTADO_REFORMA_AGRARIA"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Nome do projeto de assentamento:",
                        content:
                          _vm.imovel.registroImovel.assentamentoReforma
                            .nomeProjeto
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label:
                          "Documento comprobatório do assentamento de reforma agrária:",
                        content: _vm.formataDocumentoReformaAgraria(
                          _vm.imovel.registroImovel.assentamentoReforma
                            .documento
                        )
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _vm.imovel.registroImovel.assentamentoReforma.documento ===
                    "OUTRO"
                      ? _c("app-display", {
                          attrs: {
                            label: "Especificação:",
                            content:
                              _vm.imovel.registroImovel.assentamentoReforma
                                .outrosDocumentos
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Número do documento:",
                        content:
                          _vm.imovel.registroImovel.assentamentoReforma
                            .especificacaoDocumento
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.imovel.registroImovel.situacao === "QUILOMBOLA"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Nome do quilombo:",
                        content:
                          _vm.imovel.registroImovel.quilombola.nomeQuilombo
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Documento:",
                        content: _vm.formataDocumentoQuilombo(
                          _vm.imovel.registroImovel.quilombola.documento
                        )
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _vm.imovel.registroImovel.quilombola.documento === "OUTRO"
                      ? _c("app-display", {
                          attrs: {
                            label: "Especificação:",
                            content:
                              _vm.imovel.registroImovel.quilombola
                                .outrosDocumentos
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Número do documento:",
                        content:
                          _vm.imovel.registroImovel.quilombola
                            .especificacaoDocumento
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.imovel.registroImovel.situacao === "INDIGENA"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Terra indígena:",
                        content: _vm.imovel.registroImovel.indigena.terra
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Aldeia:",
                        content: _vm.imovel.registroImovel.indigena.aldeia
                      }
                    }),
                    _vm._v(" "),
                    _c("app-display", {
                      attrs: {
                        label: "Povo:",
                        content: _vm.imovel.registroImovel.indigena.povo
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.imovel.registroImovel.situacao === "OUTROS"
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Situação:",
                        content: _vm.formataSituacaoRegistroImovel(
                          _vm.imovel.registroImovel.situacao
                        )
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("app-display", {
                      attrs: {
                        label: "Especificação:",
                        content: _vm.imovel.registroImovel.especificacaoOutros
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-imovel" }, [_vm._v("Dados do imóvel")]),
      _vm._v(" "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _c("span", { staticClass: "title-imovel" }, [
        _vm._v("Endereço do imóvel")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-2" }, [
      _c("span", { staticClass: "title-imovel" }, [
        _vm._v("Registro do imóvel")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361912fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361912fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Imovel/Imovel.vue
// module id = null
// module chunks = 